import { render, staticRenderFns } from "./EmployeesCreatedWidget.vue?vue&type=template&id=2ccd97ff"
import script from "./EmployeesCreatedWidget.vue?vue&type=script&lang=js"
export * from "./EmployeesCreatedWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ccd97ff')) {
      api.createRecord('2ccd97ff', component.options)
    } else {
      api.reload('2ccd97ff', component.options)
    }
    module.hot.accept("./EmployeesCreatedWidget.vue?vue&type=template&id=2ccd97ff", function () {
      api.rerender('2ccd97ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/dashboard/widgets/EmployeesCreatedWidget.vue"
export default component.exports